// @flow
import type { Action, Client, GetState } from 'state/types';
import type { RTI } from 'state/types/rtiTypes';
import {
  RTI_STATUS,
  RTI_STATUS_SUCCESS,
  RTI_STATUS_FAIL,
  RTI_TOGGLE,
  RTI_TOGGLE_SUCCESS,
  RTI_TOGGLE_FAIL,
} from 'state/types/rtiTypes';
import { API } from 'util/constants';

const initialState: RTI = {
  rtiEnabled: false,
};

export default function reducer(
  state: RTI = initialState,
  action: Action
): RTI {
  switch (action.type) {
    case RTI_STATUS_SUCCESS:
      return {
        ...state,
        rtiEnabled: action.payload.isEnabled,
      };
    default:
      return state;
  }
}

function rtiToggle(session: ?string, value: boolean) {
  return {
    types: [RTI_TOGGLE, RTI_TOGGLE_SUCCESS, RTI_TOGGLE_FAIL],
    promise: (client: Client, getState: GetState) => {
      return client.post(`${API}/rti/enabled/${value.toString()}`, {
        params: { session },
      });
    },
  };
}

function getRTI(session: ?string) {
  return {
    types: [RTI_STATUS, RTI_STATUS_SUCCESS, RTI_STATUS_FAIL],
    promise: (client: Client, getState: GetState) => {
      return client.get(`${API}/rti/enabled`, {
        params: { session },
      });
    },
  };
}

const actions = {
  getRTI,
  rtiToggle,
};

export { actions };



// WEBPACK FOOTER //
// ./src/state/reducers/rtiReducer.js